enum CompanyType {
    All = 1,
    Profcoat = 2,
    VerfgroothandelHasselt = 3,
    VerfgroothandelSintTruiden = 4
}

export default CompanyType;